

export const actionDashboardEndpoint="api/lt/ltVariationCounts"; 
export const analyticsResultsGETEndipoint="api/lt/planner/runOutputItems";
export const adminAnalyticsResultsGETEndipoint="api/lt/admin/runOutputItems";
export const adminWorkflowCountEndpoint="api/lt/admin/ltResultWorkflowCounts";
export const sendToLowMaterialsEndpoint="api/lt/directSubmitWorkflow";
export const rejectWorkflowEndpoint="api/lt/planner/rejectLtRunOutput";
export const sendForApprovalEndpoint="api/lt/submitWorkflow";
export const reAssignToOthersEndpoint="api/lt/reassignWorkflow";
export const reSubmitWorkflowEndpoint="api/lt/reSubmitWorkflow";
export const editApproversWorkflowEndpoint="api/lt/planner/editWorkflowLevels";
export const getLTPlannerDropdownData="api/admin/ltPlannerMaterialDropDownData";
export const getAllUsers="api/lt/approvers";
export const getAllUsersPlannerMaterial="api/lt/planners";
export const searchLtPlannerMaterialEndpoint="api/admin/searchLtPlannerMaterial";
export const saveLtPlannerMaterialEndpoint="api/admin/saveLtPlannerMapping";
export const updateLtPlannerMaterialEndpoint="api/admin/updateLtPlannerMaterial";
export const getParamConfigDropdownEndpoint="api/admin/ltParamConfigDropDownData";
export const searchParamConfigEndpoint="api/admin/searchLtPramConfig";
export const saveParamConfigEndpoint="api/admin/saveLtParamConfig";
export const updateParamConfigSearchEndpoint="api/admin/updateLtParamConfig";
export const getApproverResultsEndpoint="api/lt/approver/runOutputItems";
export const rejectPlannerByApproverEndpoint="api/lt/rejectWorkflow";
export const sendToNextLevelApproverEndpoint="api/lt/approveWorkflow";
export const getViewAllDetailsEndpoint="api/lt/jobInputs";
export const jobCancelledEndpoint="api/admin/cancelLtJob";
export const getAllSourcePricMemo="api/cd/pricememo";
export const undoDataErrorEndpoint="api/cd/pricememo";
export const getOutboundDataEndpoint="api/lt/admin/outboundIntegrationStatus";
export const postOutboundResyncEndpoint="api/lt/admin/reSyncOutboundIntegration";
export const postOutboundResolvedEndpoint="api/lt/admin/resolveOutboundIntegration";
export const submitContractEndpoint="api/cd/contracts/submitFromEntity";
export const getJobDetailsEndpoint="api/admin/jobInputs";
export const getLTPlannerHideColumnsEndpoint="api/user/ltPlannerHiddenColumns";
export const postLTPlannerHideColumnsEndpoint="api/user/saveLtPlannerHiddenColumns";
export const getLTApproverHideColumnsEndpoint="api/user/ltApproverHiddenColumns";
export const postLTApproverHideColumnsEndpoint="api/user/saveLtApproverHiddenColumns";
export const getLTAdminHideColumnsEndpoint="api/user/ltAdminHiddenColumns";
export const postLTAdminHideColumnsEndpoint="api/user/saveLtAdminHiddenColumns";
export const editJobDetailsEndpoint="api/admin/editLtJob";
export const getReports="api/reports";
export const getGraphLeadTimeData="/api/lt/percentiles";
export const plannerGetOutboundSync="api/lt/planner/outboundIntegrationStatus";
export const resyncPlannerOutboundEndpoint="api/lt/planner/reSyncOutboundIntegration";
export const reOpenContractEndpoint="api/reports/reopenContracts";
export const viewerWorkflowCountEndpoint="api/lt/viewer/ltResultWorkflowCounts";
export const getLTViewerHideColumnsEndpoint="api/user/ltViewerHiddenColumns";
export const postLTViewerHideColumnsEndpoint="api/user/saveLtViewerHiddenColumns";
export const getContractHildeColumnsEndpoint="api/user/cdPlannerHiddenColumns";
export const postContractHildeColumnsEndpoint="api/user/saveCdPlannerHiddenColumns";
export const editSisPriceMemoEndpoint="api/cd/pricememo/saveSAPData";
export const getPriceMemoEmailEndpoint="api/cd/pricememo/price-memo-manager/emails";
export const getCpsMemberEmailEndpoint="api/cd/pricememo/cd-planners/emails";
export const getFilterContractsEndpoint = "api/cd/contracts";
export const getContractTrackingReportEndpoint = "api/reports/excelReport";
export const getContractMaintenanceEndpoint = "api/cd/contractMaintenance/filter"
export const postNewContractDataEndpoint = "api/cd/contractMaintenance/searchNewContracts"
export const postSaveContractEndpoint = "api/cd/contractMaintenance/save"
export const putDeleteContractEndpoint = "api/cd/contractMaintenance/delete";
export const postUpdateContractDataEndpoint = "api/cd/contractMaintenance/searchUpdateContracts";
export const addUpdateContractEndpoint = "api/cd/contractMaintenance/add";
export const postSubmitContractMaintenanceEndpoint = "api/cd/contractMaintenance/submitForContractFromMaintenance";
export const getNewYearContractReportsEndpoint = "api/reports/contractMaintenance";
export const postDuplicateContractEndpoint = "api/cd/contractMaintenance/duplicate";
export const downloadReportsEndpoint = "api/reports/contractMaintenance/download";
export const submitSupportTicketEndpoint = "api/cd/ticket/support-ticket";
export const getTicketSummaryDataEndpoint = "api/cd/ticket/fetch-support-tickets";
export const postUpdateTargetValueEndpoint = "api/cd/contractMaintenance/batchRun";
export const getTargetValueReportsEndpoint = "api/reports/targetBatch";
export const downloadTargetValueReportsEndpoint = "api/reports/targetBatch/download";
export const unmappedPlantsDataEndpoint = "api/cd/pricememo/sap-plant-null";
export const postUnmappedPlantsDataEndpoint = "api/cd/pricememo/update-sap-plant";
export const downloadCMTrackingReportEndpoint = "api/reports/excelReport/maintenance";
export const postArchiveDataEndpoint = "api/cd/pricememo";
export const postContractMetricsEndpoint = "api/reports/filter";
export const getDownloadCMEndpoint = "api/cd/contractMaintenance/download";
export const postUploadCMEndpoint = "api/cd/contractMaintenance/upload";
export const getCMUploadedViewEndpoint = "api/cd/contractMaintenance/excelData";
export const postRejectMultipleEndpoint = 'api/cd/pricememo';
export const postSubmitUploadEndpoint = "api/cd/contractMaintenance/submitExcelContracts";
export const priceMemoMaintenanceDataEndpoint = "api/cd/pmMaintenance";
export const savePriceMemoMaintenanceEndpoint = "api/cd/pmMaintenance";
export const uploadPriceMemoMaintenanceEndpoint = "api/cd/pmMaintenance";
export const downloadPMExcelTemplateEndpoint = "api/cd/pmMaintenance";
export const publishPriceMemoMaintenanceEndpoint = "api/cd/pmMaintenance";
export const getAuditLogsEndpoint = "api/audit";
export const getAutoTargetReviewEndpoint = "api/cd/contractMaintenance/autoTargetReview";
export const deletePriceMemoMaintenanceEndpoint = "api/cd/pmMaintenance";
export const getQuotaMaintenanceViewAllEndpoint = "api/cd/quota-maintenance/viewAll";
export const getQuotaMaintenanceHistoryEndpoint = "api/cd/quota-maintenance/history";
export const getQuotaMaintenanceAuditLogEndpoint = "api/cd/quota-maintenance/auditLog";
export const postQuotaMaintenanceFilterListEndpoint = "api/cd/quota-maintenance/viewFilterList";
export const postQuotaMaintenanceSearchEndpoint = "api/cd/quota-maintenance/searchQuota";
export const saveQuotaEndpoint = "api/cd/quota-maintenance/save";
export const duplicateQuotaEndpoint = "api/cd/quota-maintenance/duplicate";
export const calculateQuotaPercentageEndpoint = "api/cd/quota-maintenance/calculateQuotaPercentage";
export const submitQuotaEndpoint = "api/quotas/batch";
export const submitQuotaWithNumberEndpoint = "api/quotas";
export const saveAndGetQuotaSavedColumns = "api/cd/quota-maintenance/pendingSubmitPayload";

export const gmpActionDashboardEndpoint="api/lt/gmp/ltVariationCounts";
export const gmpAnalyticsResultsGETEndipoint="api/lt/gmp/runOutputItems";
export const gmpSendToLowMaterialsEndpoint="api/lt/gmp/directSubmitWorkflow";
export const gmpRejectWorkflowEndpoint="api/lt/gmp/rejectLtRunOutput";
export const gmpSendForApprovalEndpoint="api/lt/gmp/submitWorkflow";
export const gmpReSubmitWorkflowEndpoint="api/lt/gmp/reSubmitWorkflow";
export const gmpEditApproversWorkflowEndpoint="api/lt/gmp/editWorkflowLevels";
export const gmpGetClosedWorkflowEndpoint="api/lt/gmp/closedWorkflowItems";
export const gmpPlannerGetOutboundSync="api/lt/gmp/outboundIntegrationStatus";
export const gmpGetHideColumnsEndpoint="api/user/ltGmpHiddenColumns";
export const gmpPostHideColumnsEndpoint="api/user/saveLtGmpHiddenColumns";
export const gmpResyncPlannerOutboundEndpoint="api/lt/gmp/reSyncOutboundIntegration";
export const totalApproverListEndpoint="api/lt/ltWorkflowLevels";
export const rejectToInitiatorEndpoint="api/lt/rejectToInitiator";
export const createTicketOutboundEndpoint="api/lt/ticket/outbound";
export const recallPlannerEndpoint="api/lt/planner/recallWorkflow";
export const recallGMPEndpoint="api/lt/gmp/recallWorkflow";
export const addApproversEndpoint="api/lt/addApprovers";
export const getAllGMPPlannerEmailData="api/lt/gmp-planners";
export const postLTSupportTicketEndpoint="api/lt/ticket/userSupport";
export const postResolveLTSupportTicketEndpoint="api/lt/ticket/resolveUserSupport";
export const ltVariantsEndpoint="api/user/variants/lt";
export const getLTSimulationDataEndpoint="api/lt/simulate";

